import React, {useEffect, useRef, useState} from 'react';
import PropTypes from 'prop-types';
import {Button, Checkbox, Grow, MenuItem, MenuList, Paper, Typography} from "@material-ui/core";
import {useSelector} from "react-redux";
import {KeyboardArrowDown} from "@material-ui/icons";
import Popper from '@material-ui/core/Popper';
import {uid} from "react-uid";
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import _ from "lodash";
import {multiLanguageValue} from "../../../Utils/lib";
import getParamsFromString from "../../../Utils/getParamsFromString";
import JsonScreenHoc from "../../../../../HocHelpers/JsonScreenHoc";
import request from "../../../../../Services/API/Requests";

async function getListSource(listId) {
    try {
        const response = await request({
            url: "list/getData",
            data: {id: listId}
        });
        const listSource = await request({
            url: 'list/read',
            data: {id: listId}
        })
        return response.content.map(item => {
            let newObj = {};
            listSource.columns.map(col => {
                newObj[col.name] = item[col.name]
            })
            return newObj
        });
    } catch (e) {
        console.log('get list source error', e)
    }
}

const OptionsComponent = props => {
    const {component, actionsContext, screenName, setValue, doActions} = props;
    const {properties = {}, styles: sourceStyles, events} = component;
    const uniqId = uid(component);
    const [options, setOptions] = useState([])
    const [sourceOptions, setSourceOptions] = useState([])
    const [openA, setOpenA] = React.useState(false);
    const [onChangeAction, setOnChangeAction] = useState([])
    const [prevSelected, setPrevSelected] = useState([]);
    const anchorRef = useRef(null);
    const styles = sourceStyles ? sourceStyles[0] : {};
    const handleToggle = () => {
        setOpenA((prevOpen) => !prevOpen);
    };
    const cancel = () => {
        setValue(prevSelected, properties.path)
        handleToggle()
    }

    // return focus to the button when we transitioned from !open -> open
    const prevOpen = React.useRef(openA);

    useEffect(() => {
        if (prevOpen.current === true && openA === false) {
            anchorRef.current.focus();
        }

        prevOpen.current = openA;
    }, [openA]);

    const {globalValues} = useSelector(state => state.jsonScreen);
    const list = useSelector(state => state.enqueryList)
    const {userLanguage} = useSelector(state => state.app);
    const multiLanguageLabel = multiLanguageValue(properties.label, userLanguage);
    const label = getParamsFromString(multiLanguageLabel, {...actionsContext, ...globalValues, list}, screenName);
    const optionValue = getParamsFromString(`{${properties.path}}`, {...globalValues, ...actionsContext}, screenName);

    useEffect(() => {
        const onSelect = (events || []).find(e => e.event === 'onClick');
        if (onSelect) {
            setOnChangeAction(onSelect.actions.length ? onSelect.actions : [])
        }
    }, [])

    useEffect(() => {
        const onLoad = (events || []).find(e => e.event === 'onLoad');
        if (onLoad) {
            const actions = onLoad.actions;
            doActions(actions)
        }
    }, [JSON.stringify(list)])

    const onApply = () => {
        setPrevSelected(optionValue)
        handleToggle()
        if (onChangeAction) {
            doActions(onChangeAction, {doc: {value: optionValue}})
        }
    }
    const onSelectValue = (value, index) => {
        const {valueField, path, multiple} = properties;
        if (multiple) {
            if (optionValue instanceof Array) {
                const newSelected = compareObjects(optionValue, value[valueField])
                setValue(newSelected, path)
                return;
            }
            setValue([value[valueField]], path)
            return
        }
        setValue(value[valueField], path)
        if (onChangeAction) {
            doActions(onChangeAction, {doc: {object: sourceOptions[index], value: value[valueField]}})
        }
    }

    const onSelectAll = () => {
        setValue(options.map(o => o[properties.valueField]), properties.path)
    }
    const onClearAll = () => {
        setValue([], properties.path)
    }

    useEffect(() => {
        if (properties.varSource) {
            let sourceOptions = getParamsFromString(`{${properties.varSource}}`, {...globalValues, ...actionsContext}, screenName);
            if (sourceOptions.columns) {
                let newData = (sourceOptions.content || []).map(o => {
                    let newObj = {};
                    sourceOptions.columns.map(c => {
                        newObj[c] = o[c]
                    })
                    return newObj
                })
                setSourceOptions(sourceOptions.content)
                setOptions(newData);
                return
            }
            setSourceOptions(sourceOptions.content)
            setOptions(sourceOptions.content || []);
            return
        }
        if (properties.listSource) {
            async function getData() {
                const sourceOptions = await getListSource(properties.listSource);
                setOptions(sourceOptions);
            }

            getData();
        }
    }, [JSON.stringify(globalValues)])

    return (
        <div
            style={{
                padding: styles.padding,
                width: styles.width,
                height: styles.height
            }}
        >
            <Button
                id={uniqId}
                ref={anchorRef}
                onClick={handleToggle}
                endIcon={<KeyboardArrowDown/>}
                variant={"outlined"}
                style={{
                    width: '100%',
                    height: '100%'
                }}
            >
                {label}
            </Button>
            <Popper open={openA} anchorEl={anchorRef.current} role={undefined} transition disablePortal
                    style={{zIndex: 999}} placement={'bottom'}
            >
                {({TransitionProps, placement}) => (
                    <Grow
                        {...TransitionProps}
                        style={{transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom'}}
                    >
                        <Paper style={{marginTop: 50, minWidth: anchorRef.current.offsetWidth}}>
                            <ClickAwayListener onClickAway={cancel}>
                                <div>
                                    {properties.multiple && (
                                        <div style={{textAlign: 'left', padding: 3}}>
                                            <Typography variant={"caption"}
                                                        style={{
                                                            padding: 3,
                                                            textDecoration: 'underline',
                                                            cursor: 'pointer'
                                                        }}
                                                        onClick={onSelectAll}
                                            >Select All</Typography>
                                            -
                                            <Typography variant={"caption"}
                                                        style={{
                                                            padding: 3,
                                                            textDecoration: 'underline',
                                                            cursor: 'pointer'
                                                        }}
                                                        onClick={onClearAll}
                                            >Clear</Typography>
                                        </div>
                                    )}
                                    <div style={{maxHeight: 300, overflow: 'auto'}}>
                                        <MenuList
                                            autoFocusItem={openA}
                                        >

                                            {options.map((option, index) => {
                                                return (
                                                    properties.multiple ?
                                                        <MenuItemCheckboxComponent
                                                            key={uid(option)}
                                                            option={option}
                                                            onSelectValue={onSelectValue}
                                                            optionValue={optionValue}
                                                            valueField={properties.valueField}
                                                        /> :
                                                        <MenuItemComponent
                                                            key={uid(option)}
                                                            option={option}
                                                            optionValue={optionValue}
                                                            valueField={properties.valueField}
                                                            onSelectValue={onSelectValue}
                                                            closeDropdown={handleToggle}
                                                            index={index}
                                                        />

                                                )
                                            })}
                                        </MenuList>
                                    </div>
                                    {properties.multiple && (
                                        <div style={{padding: 5, display: 'flex', justifyContent: 'flex-end'}}>
                                            <Button variant={'outlined'} size={"small"} onClick={cancel}>Cancel</Button>
                                            <Button variant={'outlined'} size={"small"} style={{marginLeft: 5}}
                                                    onClick={onApply}
                                            >Apply</Button>
                                        </div>
                                    )}
                                </div>
                            </ClickAwayListener>
                        </Paper>
                    </Grow>)}
            </Popper>
        </div>
    );
};

OptionsComponent.propTypes = {
    component: PropTypes.object,
    actionsContext: PropTypes.object,
    screenName: PropTypes.string
};

export default JsonScreenHoc(OptionsComponent);

const MenuItemComponent = (props) => {
    const {option, onSelectValue, closeDropdown, optionValue, valueField, index} = props;
    const Content = () => {
        return (
            Object.keys(option).map((opt, i) => {
                return (
                    <div
                        key={uid(opt)}
                        style={{
                            display: 'inline-block',
                            paddingLeft: i === 0 ? 0 : 15,
                            whiteSpace: 'nowrap',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            maxWidth: 300
                        }}>
                        <span>{option[opt]}</span>
                    </div>
                )
            })
        )
    }
    return (
        <MenuItem
            style={{
                fontSize: '0.9rem'
            }}
            onClick={() => {
                onSelectValue(option, index);
                closeDropdown();
            }}
            selected={option[valueField] == optionValue}
        >
            <Content/>
        </MenuItem>
    )
}

const MenuItemCheckboxComponent = (props) => {
    const {option, onSelectValue, optionValue, valueField} = props;
    let isChecked = _.findIndex(optionValue, o => o === option[valueField]) !== -1;
    const Content = () => {
        return (
            Object.keys(option).map((opt, i) => {
                return (
                    <div
                        key={uid(opt)}
                        style={{
                            display: 'inline-block',
                            paddingLeft: i === 0 ? 0 : 15,
                            whiteSpace: 'nowrap',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            maxWidth: 300
                        }}>
                        <span>{option[opt]}</span>
                    </div>
                )
            })
        )
    }
    return (
        <MenuItem
            style={{padding: '0px 10px 0px 0px', fontSize: '0.9rem'}}
            onClick={() => onSelectValue(option)}
        >
            <div
                style={{paddingRight: 5, display: 'flex', alignItems: 'center'}}
            >
                <Checkbox
                    checked={isChecked}
                    size={"small"}
                />
                <Content/>
            </div>

        </MenuItem>
    )
}

function compareObjects(data, selectedRow) {
    const selectedIndex = _.findIndex(data, (o) => o === selectedRow);
    let selected = [];
    if (selectedIndex === -1) {
        selected = selected.concat(data, selectedRow);
    } else if (selectedIndex === 0) {
        selected = selected.concat(data.slice(1));
    } else if (selectedIndex === data.length - 1) {
        selected = selected.concat(data.slice(0, -1));
    } else if (selectedIndex > 0) {
        selected = selected.concat(
            data.slice(0, selectedIndex),
            data.slice(selectedIndex + 1),
        );
    }
    return selected;
}